import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Card } from "primereact/card";
import { classNames } from "primereact/utils";
import { pecaPageRows, pecaRowsPerPageOptions } from "../pages/common/envPECA";
import { getDataApi, loadApi, saveApi, updApi, delApi} from "../services/appApi";
import numeral from "numeral";
import axios from "axios";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Messages  = () => {

  const userId = sessionStorage.getItem("userId");

  let emptyRow = {
  user_id: Number(userId),
  message_name_id: null,
  app_id: null,
  message_name: "",
  message_text: "",
  message_description: "",
  message_number: null
  };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [rowDialog, setRowDialog] = useState(false); 
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const fetchStarted = useRef(false);

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi("/ords/cmn/msgNamesR");
        console.log("Response:", response);
        allData = [...allData, ...response.data.items];
        console.log("allData:", allData);
        status =  response.status;
        hasMore = response.hasMore;
        offset = offset + limit;
        }
        // console.log("Response:", response);
        // console.log("response.data.items.length: ",response.data.items.length)
        // console.log("response.data.items: ",response.data.items)
        // console.log("Fetched Data:", allData);
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = "Error";

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

   const saveRow = async () => {
    setSubmitted(true);

    if (row.message_name.trim() && row.message_number != null && row.message_text.trim()) {
      //      const isNew = !row.message_name_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };
     const p_param = {
      p_user_id: row.user_id,
      p_message_name_id: row.message_name_id,
      p_app_id: row.app_id,
      p_message_name: row.message_name,
      p_message_text: row.message_text,
      p_message_description: row.message_description,
      p_message_number: row.message_number
     }

      try {
        if (row.message_name_id) {
          /*** Update Row */
          const response = await updApi(p_param, "/ords/cmn/msgNamesCUD/v1/");
          //await axios.put(`http://localhost:5000/api/messages/${row.message_name_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.message_name_id === row.message_name_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data.o_success_flag;
          if (successFlag === "Y") {
            const index = findIndexById(row.message_name_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Message Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data.o_return_msg;
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Message Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(p_param, "/ords/cmn/msgNamesCUD/v1/");
          //const response = await axios.post('http://localhost:5000/api/messages', formattedRow);
          //       formattedRow.message_name_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data.o_success_flag; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.message_name_id =
              response.data.o_message_name_id; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Message Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data.o_return_msg;
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving message:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Message Save Failed",
          life: 3000,
          width: "600px",
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
        width: "600px",
      });
    }
  };

  const deleteRow = async () => {
    const p_param = {
      p_user_id: row.user_id,
      p_message_name_id: row.message_name_id,
    }
    console.log(p_param)
    try {
      const response = await delApi({params: p_param},"/ords/cmn/msgNamesCUD/v1/");
      console.log("response.data", response.data)
      let successFlag = response.data.o_success_flag;
      if (successFlag === "Y") {
        let _rows = rows.filter((val) => val.message_name_id !== row.message_name_id);
        setRows(_rows);
        setDeleteRowDialog(false);
        setRow(emptyRow);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Message Deleted",
          life: 3000,
          width: "600px",
        });
      } else {
        let err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Message Not Deleted",
          life: 3000,
          width: "600px",
        });
      }
    } catch (error) {
      console.error("Error deleting message:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Message Deletion Failed",
        life: 3000,
        width: "600px",
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].message_name_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const openNew = () => {
    setRow(emptyRow);
    setSubmitted(false);
    setRowDialog(true);
  };

  const hideDialog = () => {
    setShowProductDialog(false);
    setErrorDialogVisible(false);
    setRowDialog(false);
    setDeleteRowDialog(false);
  };

  const editRow = (row) => {
    setRow({ ...row });
    setRowDialog(true);
  };

  const confirmDeleteRow = (row) => {
    setRow(row);
    setDeleteRowDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Messages Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Messages
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2 p-button-rounded"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

   const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const actionBodyDeleteTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-warning"
          onClick={() => confirmDeleteRow(rowData)}
          tooltip="Delete"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

    const deleteRowDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteRow}
      />
    </React.Fragment>
  );

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  const inputRightBoxStyle = {
    textAlign: "right",
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4"> Messages </div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="message_name_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="message_number" header="Message #" style={{ textAlign: "right" }} sortable></Column>
          <Column field="message_name" header="Message Name" sortable></Column>
          <Column field="message_text" header="Message Text" sortable></Column>         
          <Column field="message_description" header="Message Description" sortable></Column>
          <Column body={actionBodyEditTemplate} style={{ width: "0.75rem" }}></Column>
          <Column body={actionBodyDeleteTemplate} style={{ width: "0.75rem" }}></Column>
        </DataTable>
      </div>
      )}

      <Dialog visible={showproductDialog} style={{ width: '600px' }} header="Messages" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="message_number">Message #</label>
                    <div className="box">
                        {row.message_number}
                    </div>

                <label htmlFor="message_name">Message Name</label>
                    <div className="box">
                        {row.message_name}
                    </div>

                <label htmlFor="message_text">Message Text</label>
                    <div className="box">
                        {row.message_text}
                    </div>

                <label htmlFor="message_description">Message Description</label>
                    <div className="box">
                        {row.message_description}
                    </div>

            </Dialog>
            <Dialog visible={rowDialog} style={{ width: '600px' }} header="Messages" modal className="p-fluid" onHide={hideDialog}>
                <div style={{paddingTop:'20px', paddingBottom: '20px'}}>
                <label htmlFor="message_number">Message #</label>
                </div>
                  <span style={{flexGrow:1}}>
                    <InputNumber
                      id="message_number"
                      value={row.message_number}
                      onValueChange={(e) => onInputChange(e, "message_number")}
                      useGrouping={false} 
                      className={classNames({
                        "p-invalid": submitted && !row.message_number,
                      })}
                      inputStyle={inputRightBoxStyle}
                    />
                  </span>
                  {submitted && !row.message_number && (
                        <small className="p-error">Message Number is required.</small>
                        )}
                <div style={{paddingTop:'20px', paddingBottom: '20px'}}>
                <label htmlFor="message_name">Message Name</label>
                 </div> 
                        <span style={{flexGrow:1}}>
                          <InputText
                            id="message_name"
                            value={row.message_name}
                            onChange={(e) => onInputChange(e, "message_name")}
                            style={inputBoxStyle}
                            required
                            autoFocus
                            className={classNames({
                              "p-invalid": submitted && !row.message_name,
                            })}
                          />
                        </span>
                        {submitted && !row.message_name && (
                        <small className="p-error">Message Name is required.</small>
                        )}
                <div style={{paddingTop:'20px', paddingBottom: '20px'}}>
                <label htmlFor="message_text">Message Text</label>
                </div>
                    <span style={{flexGrow:1}}>
                          <InputText
                            id="message_text"
                            value={row.message_text}
                            onChange={(e) => onInputChange(e, "message_text")}
                            style={inputBoxStyle}
                            required
                            autoFocus
                            className={classNames({
                              "p-invalid": submitted && !row.message_text,
                            })}
                          />
                        </span>
                        {submitted && !row.message_text && (
                        <small className="p-error">Message Text is required.</small>
                        )}
                <div style={{paddingTop:'20px', paddingBottom: '20px'}}>
                <label htmlFor="message_description">Message Description</label>
                </div>
                     <span style={{flexGrow:1}}>
                          <InputText
                            id="message_description"
                            value={row.message_description}
                            onChange={(e) => onInputChange(e, "message_description")}
                            style={inputBoxStyle}
                          />
                        </span>
                <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
            </Dialog>
           <Dialog
          visible={deleteRowDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteRowDialogFooter}
          onHide={hideDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3"
              style={{ fontSize: "1.5rem", paddingRight: "10px" }}
            />
            {row && (
              <span>
                Are you sure you want to delete <b>{row.message_name}</b>?
              </span>
            )}
          </div>
        </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            </div>
    </div>
  );
};

export default Messages;

